export default __webpack_public_path__ + "static/media/property_539.7bb8a030.png";